import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { RouteComponentProps } from 'react-router'
import usePlayground from './usePlayground'
import { DataGrid } from '@material-ui/data-grid'

import { PlaygroundViewProps } from './playgroundType'
import Divider from '@material-ui/core/Divider'
import TextField from '../../../control/textfield/textfield'
import Button from '../../../control/button/button'
import { Form } from 'react-final-form'
import I18nPlayground from './i18nPlayground/i18nPlayground'
import Autocomplete from '../../../control/autocomplete/autocomplete'
import TableExample from './Table/TableExample'
import DialogPlayground from './dialogPlayground/dialogPlayground'
import AtomPlayground from './atomPlayground/atomPlayground'
import FormPlayground from './formPlayground/formPlayground'
import ApiPlayground from './apiPlayground/apiPlayground'
import UploadFilePlayground from './uploadFilePlayground/uploadFilePlayground'
const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'firstName', headerName: 'First name', width: 130 },
    { field: 'lastName', headerName: 'Last name', width: 130 },
    {
        field: 'age',
        headerName: 'Age',
        type: 'number',
        width: 90,
    },
    {
        field: 'fullName',
        headerName: 'Full name',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 160,
        valueGetter: (params: any) => `${params.getValue('firstName') || ''} ${params.getValue('lastName') || ''}`,
    },
]

const rows = [
    { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
    { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
    { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
    { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
    { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
    { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
    { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
    { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
    { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
    { id: 11, lastName: 'Snow', firstName: 'Jon', age: 35 },
    { id: 21, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
    { id: 31, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
    { id: 41, lastName: 'Stark', firstName: 'Arya', age: 16 },
    { id: 51, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
    { id: 61, lastName: 'Melisandre', firstName: null, age: 150 },
    { id: 71, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
    { id: 81, lastName: 'Frances', firstName: 'Rossini', age: 36 },
    { id: 91, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
]

const PlaygroundView: React.FC<PlaygroundViewProps & ReturnType<typeof usePlayground>> = ({
    displayComponentKey,

    onClickPlayground,
}) => {
    const classes = useStyles()

    const display = () => {
        switch (displayComponentKey) {
            case 'LANG':
                return <I18nPlayground />
            case 'TABLE':
                return <TableExample />
            case 'DIALOG':
                return <DialogPlayground />
            case 'ATOM':
                return <AtomPlayground />
            case 'FORM':
                return <FormPlayground />
            case 'API':
                return <ApiPlayground />
            case 'UPLOAD_FILE':
                return <UploadFilePlayground />
            default:
                return <FormPlayground />
        }
    }
    return (
        <>
            <div className={classes.root}>
                <h2>Play Ground</h2>

                <div className={classes.sectionHeader}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClickPlayground('LANG')}
                        style={{ margin: '5px 0px' }}
                        fullWidth
                    >
                        Language
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClickPlayground('DIALOG')}
                        style={{ margin: '5px 0px' }}
                        fullWidth
                    >
                        Dialog
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClickPlayground('TABLE')}
                        style={{ margin: '5px 0px' }}
                        fullWidth
                    >
                        TABLE
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClickPlayground('ATOM')}
                        style={{ margin: '5px 0px' }}
                        fullWidth
                    >
                        ATOM
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClickPlayground('FORM')}
                        style={{ margin: '5px 0px' }}
                        fullWidth
                    >
                        FORM
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClickPlayground('API')}
                        style={{ margin: '5px 0px' }}
                        fullWidth
                    >
                        CALL API
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClickPlayground('NUMBER_TEXT_FIELD')}
                        style={{ margin: '5px 0px' }}
                        fullWidth
                    >
                        Number Text Field
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClickPlayground('UPLOAD_FILE')}
                        style={{ margin: '5px 0px' }}
                        fullWidth
                    >
                        Upload File
                    </Button>
                </div>
                <div className={classes.sectionContent}>{display()}</div>
            </div>
        </>
    )
}

type PlaygroundType = RouteComponentProps
const Playground = (props: PlaygroundType) => {
    const playground = usePlayground({})
    return <PlaygroundView {...playground} />
}
export default Playground

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        height: '100%',
    },
    sectionHeader: {
        width: '100%',
        height: '170px',
        backgroundColor: 'pink',
        overflow: 'auto',
    },
    sectionContent: {
        width: '100%',
        height: 'calc(100% - 170px)',
        overflow: 'auto',
    },
}))
